import { ADD_SEARCH_TERM, SEARCH_SUBMIT } from '../constants/action-types';

const initState = {
  searchTerm: '',
  searchVersion: 0
}

const searchReducer = (state = initState, action) => {
  switch (action.type) {
    case ADD_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.searchInput
      }

    case SEARCH_SUBMIT:
      return {
        ...state,
        searchVersion: state.searchVersion + 1
      }

    default:
      return state
  }
}

export default searchReducer;